import { CreditCardFastOutlineIcon } from './CreditCardFastOutlineIcon';

/**
 * author: Jeff Anders
 * id B08C2F32-A29A-4429-BFDA-97F81B704A65
 * name credit-card-fast-outline
 * version: 6.4.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/credit-card-fast-outline.svg
 * tags
 * - Banking 
 */
export const CreditCardSwipeOutlineIcon = CreditCardFastOutlineIcon;
export default CreditCardSwipeOutlineIcon